if (!customElements.get('mbito-market-selector')) {
  customElements.define('mbito-market-selector', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const details = this.querySelector('details');
      const trigger = details.querySelector('summary');
      const header = this.closest('.header-wrapper');
      const close = (restoreFocus = false) => {
        details.open = false;
        trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) trigger.focus();
      };
      const measure = () => {
        if (details.open) this.style.setProperty('--mbito-market-header-bottom', `${header.getBoundingClientRect().bottom}px`);
      };
      const updateReturns = () => {
        const params = new URLSearchParams(window.location.search);
        ['country', 'currency', 'locale'].forEach(key => params.delete(key));
        const query = params.toString();
        this.querySelectorAll('[data-mbito-return-path]').forEach(button => {
          button.form.elements.return_to.value = button.dataset.mbitoReturnPath + (query ? `?${query}` : '') + window.location.hash;
        });
      };
      trigger.setAttribute('aria-expanded', String(details.open));
      updateReturns();
      details.addEventListener('toggle', () => {
        trigger.setAttribute('aria-expanded', String(details.open));
        if (!details.open) return;
        const drawer = header.querySelector('header-drawer');
        const drawerSummary = drawer?.querySelector('details[open] > summary');
        if (drawerSummary) {
          drawer.closeMenuDrawer(new Event('close'), trigger);
          drawerSummary.setAttribute('aria-expanded', 'false');
          trigger.focus();
        }
        measure();
        updateReturns();
      }, { signal });
      const closeButton = this.querySelector('.mbito-market__close');
      closeButton.hidden = false;
      closeButton.addEventListener('click', () => close(true), { signal });
      document.addEventListener('click', event => {
        if (details.open && !this.contains(event.target)) close();
      }, { signal });
      document.addEventListener('keydown', event => {
        if (details.open && event.key === 'Escape') {
          event.preventDefault();
          close(true);
        }
      }, { signal });
      document.addEventListener('toggle', event => {
        if (event.target !== details && header.contains(event.target) && event.target.open) close();
      }, { signal, capture: true });
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) close();
      }, { signal });
      this.addEventListener('submit', updateReturns, { signal });
      window.addEventListener('resize', measure, { signal });
      window.addEventListener('scroll', measure, { signal, passive: true });
      if (this.hasAttribute('data-mbito-needs-selection')) {
        let prompted = false;
        try {
          prompted = sessionStorage.getItem('mbito-market-prompted') === 'true';
          sessionStorage.setItem('mbito-market-prompted', 'true');
        } catch {}
        details.open = !prompted;
        trigger.setAttribute('aria-expanded', String(details.open));
        measure();
      } else {
        try { sessionStorage.removeItem('mbito-market-prompted'); } catch {}
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
